import { rd } from '@passionware/monads';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveAccount } from '../../../../store/accounts';
import {
  selectActiveAccountId,
  selectActiveTeamId
} from '../../../../store/session';
import { selectTeams } from '../../../../store/teams';
import { ContextService } from './ContextService';

export function createContextService(): ContextService {
  return {
    useWorkspaceName(workspaceId: string) {
      const teams = useSelector(selectTeams);
      const team = useMemo(
        () => Object.values(teams).find(team => team.dbSchema === workspaceId),
        [teams, workspaceId]
      );
      if (!team) {
        // Team not found - could be loading or doesn't exist
        return rd.ofPending();
      }
      return rd.of(team.name);
    },

    useWorkspaceId() {
      const teamId = useSelector(selectActiveTeamId);
      if (!teamId) {
        return rd.ofIdle(); // no team id set
      }
      return rd.of(teamId);
    },

    useAccountName() {
      const account = useSelector(selectActiveAccount);
      if (!account) {
        return rd.ofPending();
      }
      const fullName = [account.firstName, account.lastName]
        .filter(Boolean)
        .join(' ');
      return rd.of(fullName || account.displayName || account.email);
    },

    useAccountId() {
      const accountId = useSelector(selectActiveAccountId);
      if (!accountId) {
        return rd.ofIdle(); // no account id set
      }
      return rd.of(accountId);
    }
  };
}
